var $ = require('jquery');
/**
 * Notification
 *
 * @depends toolbar.js
 * @depends notification-module.js
 */
(function() {

    var NotificationCenter;

    NotificationCenter = Klazz.extend({
        options: {},
        toolbar: null,
        element: null,
        messages: {

        },
        /**
         * Element that trigger opening/closing of Notification Center
         */
        bell: null,
        /**
         * Element used as root for angular module (inside layer)
         */
        ngRootEl: null,

        initialize: function(toolbar) {
            this.toolbar = toolbar;
            // Only available in the editor toolbar
            if (diy.context.type != 'editor') {
                return;
            }

            // note: we break object reference
            this.options = $.extend(true, {}, this.options);

            // get translations //
            // note: we break object reference
            // this.messages = $.extend(true, {}, this.messages, jimdoData.messages.notificationCenter);

            this.draw();
        },
        updateUnreadCountBubble: function(number) {
            var count = parseInt(number, 10),
                countText;

            var unreadBubble = this.element.find('.unread-count');

            if (count === 0) {
                unreadBubble.hide();
            } else {
                unreadBubble.show();
            }

            if (count > 9) {
                countText = '9+';
            } else {
                countText = count;
            }
            unreadBubble.html(countText);
        },

        draw: function() {
            var elementHtml = '' +
            '<div class="notificationBellContainer">' +
                '<a class="notificationBell" title="' + jimdoData.messages.toolbar.tooltipNotifications + '">' +
                    '<div class="icon"></div>' +
                    '<span class="unread-count"></span>' +
                '</a>' +
            '</div>' +
            '<div class="spacer"><div class="icon"></div></div>';
            this.element = this.toolbar.pushToPanel('left', elementHtml, true);

            this.bell = this.element.find('.notificationBell');

            this.bell
            .bind('click', $.proxy(this._toggleLayer, this))
            .diy_calloutLayer({
                //lazyRender: true,
                cls: 'diye-toolbar-notificationCenter',
                anchorTarget: this.bell,
                positionMode: 'fixed',
                position: {
                    my: 'left top',
                    at: 'left bottom',
                    offset: (diy.editor.uiPreference.isPointerModeTouch() ? '-6 8' : '-10 3')
                },
                render: $.proxy(this._renderLayer, this),
                show: $.proxy(function() {
                    this.bell.addClass('callout-open');
                    this.markAllAsRead();
                    this.dismissAllBubbles();
                    $(document).trigger('diy-editor-generic-sectionAccessed', {
                        sectionCodeName: 'notificationCenter'
                    });
                }, this),
                hide: $.proxy(function() {
                    if (this.bell.hasClass('callout-open')) {
                        this.bell.removeClass('callout-open');
                        $(document).trigger('diy-editor-notification-center-closed');
                    }
                }, this)
            });

            this.bell.diy_calloutLayer('render');
            $('#diyToolbar').bind('diy-editor-toolbar-repositioned', $.proxy(this._positionLayer, this));
        },

        _getLayerTemplate: function() {
            // The template is defined inline in the angular module
            return '<div ng-controller="NotificationFlyoutCtrl" ng-include="\'notificationFlyout.html\'"></div>';
        },

        _renderLayer: function(e, layer) {
            var contentEl = layer.getContentEl();

            if (!contentEl) {
                return;
            }

            this.ngRootEl = $(this._getLayerTemplate()).appendTo(contentEl);
            angular.bootstrap(this.ngRootEl, ['diy.notification.flyout']);

            contentEl.diy_scrollHandle();
        },

        isLayerOpened: function() {
            return this.bell.diy_calloutLayer("isVisible");
        },

        _toggleLayer: function() {
            var visible = this.bell.diy_calloutLayer("isVisible");
            this.bell.diy_calloutLayer(visible ? 'hide' : 'show');
            this.refreshScroller();
        },

        hideLayer: function() {
            this.bell.diy_calloutLayer('hide');
        },

        // Public API (called by angular controller)
        refreshScroller: function() {
            var contentEl = this.bell.diy_calloutLayer('getContentEl');

            if (!contentEl || !this.bell.diy_calloutLayer('isVisible')) {
                return;
            }

            contentEl
                .trigger('contentchanged')
                .diy_alwaysInViewBehavior({
                    clickToOpen: true,
                    fixableSelector: '.diye-collapsible-category-header',
                    fixedClassName: 'fixed',
                    activeClassName: 'active'
                });
        },

        _positionLayer: function() {
            this.bell.diy_calloutLayer('refresh');
        },

        markAllAsRead: function() {
            angular.injector(['diy.notification']).invoke(['ntfApi', function(ntfApi) {
                ntfApi.markAllAsRead();
            }]);
        },

        dismissAllBubbles: function() {
            angular.injector(['diy.notification']).invoke(['ntfApi', function(ntfApi) {
                ntfApi.markAllAsDismissed();
            }]);
        }
    });

    module.exports = NotificationCenter;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/NotificationCenter.js
 ** module id = 677
 ** module chunks = 0
 **/